// Third party
import React from 'react';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import { PERMISSIONS, userHasPermission } from '@/utils/permissions';

// Components
import ComparisonActionCards from '@/views/components/misc/ComparisonActionCards';
import ComparisonQuickSearch from '@/views/containers/comparison/misc/ComparisonQuickSearch';
import StatusFeedbackModal from '@/views/components/modals/StatusFeedbackModal';
import { CloseButton } from '@/views/components/buttons';

// Types
import User from '@/types/user';
import { Status } from '@/types/status';
import { connect } from 'react-redux';
import { ReduxState } from '@/redux/modules/types';
import { ADD_FUNDS_TO_COMPARISON, ADD_PORTFOLIOS_TO_COMPARISON } from '@/redux/modules/comparison';
import FormattedMessageV2, { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type StateProps = {
  comparisonIsLoading: boolean;
};

type Props = {
  user: User;
  onCloseComparison?: () => void;
  showModelPortfoliosModal: () => void;
  showContactPortfoliosModal: () => void;
  showEditPortfolioModal: () => void;
} & StateProps;

const StartComparison = ({
  comparisonIsLoading,
  user,
  onCloseComparison,
  showModelPortfoliosModal,
  showContactPortfoliosModal,
  showEditPortfolioModal,
}: Props) => (
  <div className="empty-comparison">
    {onCloseComparison && <CloseButton dark withText onClick={onCloseComparison} />}

    <div className="empty-comparison-container">
      <div className="empty-comparison-content">
        <div className="title">
          <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.H1} toLocalize="EmptyComparison.Title" />
          <FormattedMessage tagName="p" id="EmptyComparison.Subtitle" />
        </div>

        <ComparisonQuickSearch user={user} />

        <ComparisonActionCards
          className="empty-options"
          hasClientAccountPermission
          hasModelPortfolioPermission={userHasPermission(user, PERMISSIONS.USER_MODELS) || userHasPermission(user, PERMISSIONS.ENTERPRISE_MODELS_LIST)}
          hasNewPortfolioPermission
          onClickClient={showContactPortfoliosModal}
          onClickModel={showModelPortfoliosModal}
          onClickPortfolio={showEditPortfolioModal}
        />
        <StatusFeedbackModal show={comparisonIsLoading} status={Status.LOADING} i18nBasePath="Comparison" isDelayed />
      </div>
    </div>
  </div>
);

const mapStateToProps = (state: ReduxState) => ({
  comparisonIsLoading: !!state.ui.loaders.actions.find(loader => [ADD_FUNDS_TO_COMPARISON.type, ADD_PORTFOLIOS_TO_COMPARISON.type].includes(loader.name)),
});

export default connect(mapStateToProps, {})(StartComparison);
